import React, { useState, useEffect, useContext } from 'react';
import './DescriptionBox.css';
import { ShopContext } from '../../Context/ShopContext'; // افتراض أن السياق يحتوي على بيانات المستخدم

const DescriptionBox = ({ product }) => {
  const [activeTab, setActiveTab] = useState("description");
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [comment, setComment] = useState('');
  const { userName } = useContext(ShopContext); // استرداد اسم المستخدم من السياق

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await fetch(`http://localhost:4000/getreviews/${product.id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setReviews(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching reviews:", error);
        setLoading(false);
      }
    };
    fetchReviews();
  }, [product.id]);

  const reviewCount = reviews.length;

  const handleAddReview = async () => {
    if (!comment) {
      alert('Please enter a comment');
      return;
    }
    try {
      const response = await fetch('http://localhost:4000/addreview', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productId: product.id,
          userName: userName || 'Anonymous', // استخدام اسم المستخدم أو "Anonymous" إذا لم يكن موجودًا
          comment,
        }),
      });
      const data = await response.json();
      if (data.success) {
        setComment('');
        // إعادة جلب التقييمات لتحديث القائمة
        const updatedResponse = await fetch(`http://localhost:4000/getreviews/${product.id}`);
        const updatedData = await updatedResponse.json();
        setReviews(updatedData);
      } else {
        alert('Failed to add review');
      }
    } catch (error) {
      console.error("Error adding review:", error);
      alert('Error adding review');
    }
  };

  return (
    <div className='descriptionbox'>
      <div className="descriptionbox-navigator">
        <div
          className={`descriptionbox-nav-box ${activeTab === "description" ? "active" : ""}`}
          onClick={() => setActiveTab("description")}
        >
          Description
        </div>
        <div
          className={`descriptionbox-nav-box ${activeTab === "reviews" ? "active" : ""}`}
          onClick={() => setActiveTab("reviews")}
        >
          Reviews ({reviewCount})
        </div>
      </div>

      <div className="descriptionbox-content">
        {activeTab === "description" && (
          <div className="descriptionbox-description">
            {product.description || "No description available"}
          </div>
        )}
        {activeTab === "reviews" && (
          <div className="descriptionbox-reviews">
            {loading ? (
              <p>Loading reviews...</p>
            ) : reviews.length > 0 ? (
              reviews.map((review, index) => (
                <div key={index}>
                  <strong>{review.userName}:</strong> {review.comment}
                </div>
              ))
            ) : (
              <p>No reviews available</p>
            )}
            {/* إضافة حقل لكتابة التقييمات بدون حقل الاسم */}
            <div className="descriptionbox-add-review">
              <textarea
                placeholder="Write your review..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                rows="4"
              />
              <button onClick={handleAddReview}>Add Review</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DescriptionBox;